import { Injectable } from '@angular/core';
import { HttpParams, HttpHeaders, HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { APIURLConstantsService } from '../../../services/api-url-service/apiurlconstants.service';


@Injectable()
export class SeguimentTecnicService {
  public getTipus(){
    return this.authHttp.get<any>(APIURLConstantsService._API_BASE_URL + "sttipus").pipe(map(response => response || []));
  }
  
  public getSubTipus(idT) {
    return this.authHttp.get<any>(APIURLConstantsService._API_BASE_URL + "stsubtipus/"+idT).pipe(map(response => response || []));
  }

  constructor(private authHttp: HttpClient) {}

}
